import { cn } from "@/lib/utils";

export function Panel({ title, action, className, contentClassName, children, ...props }) {
  return (
    <section
      className={cn(
        "flex flex-col rounded-xl border border-white/[0.06] bg-sentinel-card shadow-[0_20px_60px_-30px_rgba(0,0,0,0.9)]",
        className
      )}
      {...props}
    >
      {title && (
        <div className="flex items-center justify-between border-b border-white/[0.06] px-5 py-3">
          <h2 className="font-mono text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400">
            {title}
          </h2>
          {action}
        </div>
      )}
      <div className={cn("p-5", contentClassName)}>{children}</div>
    </section>
  );
}
